import React, { useEffect } from 'react';
import { PageHeader } from '../components/PageHeader';
import { QuickStartGuide } from '../components/QuickStartGuide';
import { SiteFooter } from '../components/SiteFooter';
import { trackCustom } from '../utils/tracking';

/** /guide · the Quick Start Guide QR code destination. */
export function Guide() {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackCustom('quick_start_page_visited');
  }, []);
  return <div className="min-h-full w-full bg-ink-950 font-sans text-offwhite" data-id="element-1750" data-mp="crzap15rhb4r">
      <PageHeader data-id="element-1751" data-mp="8sqezqr5v36k" />
      <main data-id="element-1752" data-mp="8rff420u6fkq">
        <QuickStartGuide headingLevel="h1" data-id="element-1753" data-mp="8rovcxw2x8d8" />
      </main>
      <SiteFooter data-id="element-1754" data-mp="mjlieniw4s2r" />
    </div>;
}